import React, { Component } from 'react';
import { stack as Menu } from 'react-burger-menu';
import { Accordion, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

class MenuGeneral extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  closeMenu () {
    this.setState({menuOpen: false});
  }

  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})  
  }

render () {
  // let user = JSON.parse(localStorage.getItem('user'));
  const {optMenu} = this.props;
  
  const LevelContent = idpadre => optMenu.map((row, index) => {
    if(idpadre === row.cMenClavePadre && row.cMenLink != null){
      return(
        <li key={row.cMenClave}>
          <Link 
            onClick={() => this.closeMenu()} 
            to={row.cMenLink}>
            <Icon name={row.cMenIcono} />
            {row.cMenLinkText}
          </Link>
        </li>
      );
    }
  });

  const rootPanels = optMenu.map((row, index) => {
    if (row.cMenNivel === 0){
      return({ 
        key: row.cMenClave, 
        title: row.cMenLinkText, 
        content: { 
          content: <div>{LevelContent(row.cMenClave)}</div>
          }
        });
    }
  });

  const user = JSON.parse(localStorage.getItem('user'));


    return (
      <Menu 
        isOpen={this.state.menuOpen}
        onStateChange={(state) => this.handleStateChange(state)}
      >
        <ul>
          <div className="perfil_usuario">
            <label>Hola {user.cUsuNombre}</label>
            <br></br>
            <Link to="/profile"><Icon name='user' />Mi cuenta</Link>
          </div>
        </ul>
        <ul>
          <div className="perfil_usuario">
            <Link to="/documentos"><Icon name='file' />Documentos</Link>
          </div>
        </ul>
       
        <ul>
          <Accordion panels={rootPanels}  />
        </ul>
      </Menu>
    );
  }
}




export default MenuGeneral